import { API_ROOT } from '../../config/config'

import { doGet, doDownload } from './utils'

export const getProposalPreviewForm = (projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/overview/print-preview`
  return doGet(url)
}

export const getProposalForm = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/proposal/form`
  return doDownload(url)
}

export const getProposalFormUrl = (projectVersionId) => {
  return `${API_ROOT}/files/${projectVersionId}/proposal/form`
}

export const getProposalFormx = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/proposal/formx`
  return doGet(url)
}

export const getAppSettings = () => {
  const url = `${API_ROOT}/files/app-settings`
  return doGet(url)
}

export const getSystemDoc = (pathFile) => {
  const url = `${API_ROOT}/portal/doc/download/sys-doc?filePath=${pathFile || ''}`
  return doDownload(url)
}
